import React, { useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import { getApplicableL2CompanyModules } from 'Deer/components/navigation/secondary/Company/CompanyModules';
import { useCustomNameGoalsCompanyTabs } from 'Deer/hooks/useCustomNameGoalsCompanyTabs';
import { IntentDropdown } from 'Deer/intent/Goals/components/IntentDropdown';
import { Layout } from 'Deer/intent/components/Layout/Layout';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch } from 'react-redux';
import { setSelectedView } from 'reducers/viewsSlice';
import Header from 'screens/Team/Rabbit/Goals/Header';
import GoalPreferences from 'screens/admin/Objectives/GoalPreferences';
import { checkIntentLandingPagesFeatureEnabled } from 'utils/helpers/featureFlags';

import { modifyString, StringModifier } from 'constants/copyHelpers';
import { sendPageViewEvent } from 'constants/mixpanelHelper';

import { PageTabbedNavigationV1 } from 'uiToolkitV1/PageTabbedNavigationV1';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cohort: any;
  headerLabel: string;
}

const CompanyGoalsSettings = ({ cohort, headerLabel }: Props) => {
  const dispatch = useDispatch();
  const { tabs } = useCustomNameGoalsCompanyTabs();
  const { moduleName } = useOrganisationSettings();
  const modifiedHeaderLabel = `${headerLabel} ${modifyString(moduleName, StringModifier.PLURAL_SENTENCE_CASE)}`;
  const applicableL2CompanyModules = getApplicableL2CompanyModules(moduleName) ?? [];

  useEffect(() => {
    dispatch(setSelectedView({ ...cohort, teamId: cohort.id }));
    return () => {
      dispatch(setSelectedView({}));
    };
  }, [cohort]);

  useEffect(() => {
    sendPageViewEvent({
      eventProperties: {
        page: 'Company-goals-settings',
      },
    });
  }, []);

  if (checkIntentLandingPagesFeatureEnabled()) {
    return (
      <Layout
        Filters={
          <IntentDropdown
            showKebabMenu={false}
            breadcrumbs={{
              items: [
                {
                  label: 'Company',
                  to: applicableL2CompanyModules[0]?.value,
                },
              ],
              page: {
                label: modifyString(moduleName, StringModifier.PLURAL_TITLE_CASE),
                to: '',
              },
            }}
          />
        }
      >
        <GoalPreferences />
      </Layout>
    );
  }

  return (
    <Box w="100%">
      <Header showTimeline={false} teamName={modifiedHeaderLabel} />

      <PageTabbedNavigationV1 tabs={tabs} />
      <GoalPreferences />
    </Box>
  );
};

export default CompanyGoalsSettings;
